import * as React from "react";

export const CloseIcon = (props: any) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size || 20} height={props.size || 20} viewBox="0 0 20 18">
      <path
        d="M17.3789 0.294373C17.7695 -0.0960567 18.4025 -0.0961196 18.793 0.294373C19.1833 0.684883 19.1833 1.31797 18.793 1.70844L11.4141 9.08734L18.6182 16.2914L18.6875 16.3666C19.0078 16.7594 18.9843 17.3394 18.6182 17.7055C18.2522 18.0714 17.673 18.0947 17.2803 17.7748L17.2041 17.7055L10 10.5014L2.79592 17.7055L2.71974 17.7748C2.32705 18.0948 1.74787 18.0713 1.38185 17.7055C1.01575 17.3394 0.992197 16.7594 1.31252 16.3666L1.38185 16.2914L8.58596 9.08734L1.20705 1.70844C0.816544 1.31793 0.816582 0.684902 1.20705 0.294373C1.59757 -0.096151 2.23059 -0.096151 2.62111 0.294373L10 7.67328L17.3789 0.294373Z"
        fill={props.fill || "#3F3F3F"}
      />
    </svg>
  );
};
